import { render, staticRenderFns } from "./Borme.vue?vue&type=template&id=7ee55b9a"
import script from "./Borme.vue?vue&type=script&lang=js"
export * from "./Borme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports